import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTime',
})
export class SecondsToTimePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    if (!value || value < 0) return '-';

    // Time units in seconds
    const units = [
      { label: 'سال', seconds: 31536000 },  // 60 * 60 * 24 * 365
      { label: 'ماه', seconds: 2592000 },   // 60 * 60 * 24 * 30
      { label: 'هفته', seconds: 604800 },   // 60 * 60 * 24 * 7
      { label: 'روز', seconds: 86400 },     // 60 * 60 * 24
      { label: 'ساعت', seconds: 3600 },     // 60 * 60
      { label: 'دقیقه', seconds: 60 },
      { label: 'ثانیه', seconds: 1 },
    ];

    let remainingTime = value;
    let result = '';
    let stepsTaken = 0; // Track how many steps we've taken

    // Loop through the units array to break down the total time into units
    for (let i = 0; i < units.length; i++) {
      const unitValue = Math.floor(remainingTime / units[i].seconds);
      if (unitValue > 0) {
        if (result) result += ' و ';
        result += `${unitValue} ${units[i].label}`;
        remainingTime %= units[i].seconds;  // Reduce the remaining time
        stepsTaken++;

        // Stop after two steps
        if (stepsTaken === 2) break;
      }
    }

    return result || '-';
  }
}
